export const newsPath = {
  /* inject path */
  EDIT_EDITOR_DETAILS: '/news/edit-editor-details/:id',
  EDIT_EDITOR_DETAILS_URI: '/news/edit-editor-details',
  EDITOR_DETAILS: '/news/editor-details/:id',
  EDITOR_DETAILS_URI: '/news/editor-details',
  EDITOR_TABLE: '/news/editor-table',
  SOURCE_EDITIONS_DETAILS: '/news/source-editions-details/:id',
  SOURCE_EDITIONS_DETAILS_URI: '/news/source-editions-details',
  SOURCE_EDITION_TABLE: '/news/source-edition-table/:id?/:name?',
  SOURCE_EDITION_TABLE_URI: '/news/source-edition-table',
  ADD_PARENT_SOURCE: '/news/add-parent-source',
  EDIT_SOURCE: '/news/edit-source/:id',
  EDIT_SOURCE_URI: '/news/edit-source',
  EDIT_SOURCE_EDITION: '/news/edit-source-edition/:id',
  EDIT_SOURCE_EDITION_URI: '/news/edit-source-edition',

  EDIT_CATEGORY: '/news/edit-category/:id',
  EDIT_CATEGORY_URI: '/news/edit-category',
  SUBCATEGORY: '/news/categories-table/:id/:name',
  SUBCATEGORY_URI: '/news/categories-table',
  CATEGORIES_TABLE: '/news/categories-table',
  SOURCE_DETAILS: '/news/source-details/:id',
  SOURCE_DETAILS_URI: '/news/source-details',

  SOURCES_TABLE: '/news/sources-table',
  ADD_NEW_CATEGORIES: '/news/add-new-category',
  NEWS_DETAILS: '/news/news-details/:id',
  NEWS_DETAILS_URI: '/news/news-details',

  TAGS_TABLE: '/news/tags-table',
  EDIT_AUTHOR_DETAILS: '/news/edit-author-details/:id',
  EDIT_AUTHOR_DETAILS_URI: '/news/edit-author-details',

  AUTHOR_DETAILS: '/news/author-details/:id',
  AUTHOR_DETAILS_URI: '/news/author-details',

  ADD_SOURCE: '/news/add-source',
  ADD_SOURCE_EDITION: '/news/add-source-edition',
  AUTHORS_TABLE: '/news/authors-table',
  NEWS_TABLE: '/news/news-table',
  DASHBOARD: '/news/dashboard',
};
